<div class="px-3 py-2 d-flex align-items-center">
  <ng-content></ng-content>
</div>
